import {
  CoachMarkAnchor,
  CoachMarkContent,
  CoachMarkDescription,
  CoachMarkDismiss,
  CoachMarkFooter,
  CoachMarkRoot,
  CoachMarkTitle,
} from './coach-mark';

/**
 * CoachMark — a persistent, instructional callout that points at a UI element
 * and explains it. Modeled on Adobe Spectrum's Coach mark spec.
 *
 * Unlike a Tooltip (hover-only) or a Popover (click-outside dismiss), a coach
 * mark stays open until the user explicitly takes an action — there's no
 * auto-dismiss timeout. Consumers own persistence; the primitive only manages
 * `open`.
 *
 * <CoachMark.Root open={open} onOpenChange={setOpen}>
 *   <CoachMark.Anchor asChild>
 *     <TabsTrigger value="transcript">Transcript</TabsTrigger>
 *   </CoachMark.Anchor>
 *   <CoachMark.Content side="bottom" align="end">
 *     <CoachMark.Title>Transcript moved here</CoachMark.Title>
 *     <CoachMark.Description>
 *       Open this tab any time during a meeting to follow your live transcript.
 *     </CoachMark.Description>
 *     <CoachMark.Footer>
 *       <CoachMark.Dismiss asChild>
 *         <Button>Got it</Button>
 *       </CoachMark.Dismiss>
 *     </CoachMark.Footer>
 *   </CoachMark.Content>
 * </CoachMark.Root>
 */
export namespace CoachMark {
  export const Root = CoachMarkRoot;
  export const Anchor = CoachMarkAnchor;

  export const Content = CoachMarkContent;

  export const Title = CoachMarkTitle;

  export const Description = CoachMarkDescription;
  export const Footer = CoachMarkFooter;
  export const Dismiss = CoachMarkDismiss;
}
